// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-no-translate]{translate:none;-webkit-user-select:none;-moz-user-select:none;user-select:none}.dkDOI{border:1px solid #fff;color:#fff;margin:0 5px;min-height:31px;padding:2px 8px}@media only screen and (max-width: 767px){.dkDOI{background-color:var(--whitelabeling-primary-color)}.dkDOI:hover{background-color:var(--whitelabeling-primary-dark-color)}}.dkDOI.oq84H{color:#fff}@media only screen and (max-width: 767px){.oq84H{background-color:#a2a2a2}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"btn": "dkDOI",
	"disabled": "oq84H"
};
module.exports = ___CSS_LOADER_EXPORT___;
